import styled from "@emotion/styled";

import { FONT_WEIGHT_SEMI_BOLD } from "../utilities";

export const AdornmentIcon = styled.div`
  width: 16px;
  height: auto;
  flex: 0 0 16px;
  margin: 0 6px 4px 0;

  font-size: ${({ theme }) => theme.fontSizeSmall};
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  text-align: center;
  line-height: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:active,
  &:focus {
    pointer-events: none; // Prevents the label from stealing focus from the input.
  }

  > svg {
    width: 16px;
    height: 16px;
  }
  i {
    font-size: 13px;
  }
`;
